import { Card, CardBody, Divider, Button } from "@heroui/react";
import { LuSave } from "react-icons/lu";
import { ThemedText } from "@/components/ui";
import { formatCurrency } from "@/utils";
import { twMerge } from "tailwind-merge";

const ReturnSummary = ({
    totalReturnAmount,
    activeItemCount,
    isValid,
    isSaving,
    isSubmitting,
    className = "",
}) => {
    return (
        <Card
            className={twMerge("border-default-200 border", className)}
            shadow="none"
        >
            <CardBody className="p-5">
                <div className="flex flex-col gap-1">
                    <ThemedText size="xs" variant="secondary">
                        Total Estimasi Retur
                    </ThemedText>
                    <ThemedText size="2xl" className="font-bold">
                        {formatCurrency(totalReturnAmount)}
                    </ThemedText>
                    <ThemedText size="xs" variant="secondary" className="mt-2">
                        {activeItemCount} barang dipilih untuk diretur
                    </ThemedText>
                </div>
                <Divider className="my-4" />
                <Button
                    type="submit"
                    color="primary"
                    className="w-full font-medium"
                    startContent={<LuSave />}
                    isDisabled={
                        !isValid ||
                        isSaving ||
                        isSubmitting ||
                        activeItemCount === 0
                    }
                >
                    Simpan Retur
                </Button>
            </CardBody>
        </Card>
    );
};

export default ReturnSummary;
